import { IPhraseTrigger } from "@edgetier/watchtower-types";

/**
 * Create an array with the message source types for phrase trigger.
 * @param phraseTrigger The phrase trigger who's message sources we want to know.
 * @returns An array of message source types.
 * @example ["Customer", "Agent", "Bot"]
 */
export const createMessageSourceFromPhraseTrigger = (
    phraseTrigger: Pick<IPhraseTrigger, "inboundMessages" | "outboundMessages" | "botMessages">
) => {
    const { inboundMessages, outboundMessages, botMessages } = phraseTrigger;
    const messageSource = (["Customer", "Agent", "Bot"] as const).filter(
        (item) =>
            (item === "Customer" && inboundMessages) ||
            (item === "Agent" && outboundMessages) ||
            (item === "Bot" && botMessages)
    );

    return messageSource;
};
